import PropTypes from 'prop-types';
import React, { Component } from 'react';

// A Select widget that displays and switches the current locale
export default class LocaleSwitcher extends Component {

  static propTypes = {
    locale: PropTypes.string.isRequired,
    setLocale: PropTypes.func.isRequired,
    selectClassName: PropTypes.string,
  }

  constructor() {
    super();

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    this.props.setLocale(e.target.value);
  }

  render() {
    return (
      <select
        id='localeSelect'
        data-test-name='locale-select'
        className={this.props.selectClassName}
        onChange={this.handleChange}
        value={this.props.locale}
      >
        <option value='en'>English (U.S.)</option>
        <option value='en-GB'>English</option>
        <option value='fr'>Français</option>
        <option value='de'>Deutsch</option>
        <option value='it'>Italiano</option>
        <option value='es'>Español</option>
        <option value='ja'>Nihongo</option>
      </select>
    );
  }
}



// WEBPACK FOOTER //
// ./src/portfolio-shared/view/Login/LocaleSwitcher.js